import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
  Signal,
  inject,
} from '@angular/core';

import { Carousel } from 'primeng/carousel';
import { PublicProductsForSaleTileComponent } from '../public-products-for-sale-tile/public-products-for-sale-tile.component';
import {
  BreakpointService,
  ResponsiveCarouselOptions,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { toSignal } from '@angular/core/rxjs-interop';
import { PublicAvailableProduct } from '../../models/public-available-product';

@Component({
  selector: 'app-public-products-for-sale-carousel',
  imports: [
    Carousel,
    PublicProductsForSaleTileComponent,
    SpinnerFilledComponent,
  ],
  templateUrl: './public-products-for-sale-carousel.component.html',
  styleUrl: './public-products-for-sale-carousel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicProductsForSaleCarouselComponent {
  private readonly breakpoint = inject(BreakpointService);

  public readonly products = input.required<PublicAvailableProduct[]>();

  protected readonly shouldShowAsCarousel = this.shouldShowAsCarouselSignal();
  protected readonly responsiveOptions = this.responsiveOptionsSignal();

  private shouldShowAsCarouselSignal(): Signal<boolean> {
    const moreThanLimitSignal = this.moreThanLimitSignal();
    const isMobileSignal = this.isMobileSignal();

    return computed(() => moreThanLimitSignal() || isMobileSignal());
  }

  private isMobileSignal(): Signal<boolean> {
    return toSignal(this.breakpoint.observe('max-sm'), {
      initialValue: false,
    });
  }

  private moreThanLimitSignal(): Signal<boolean> {
    const limit = 3;

    return computed(() => this.products().length > limit);
  }

  private responsiveOptionsSignal(): Signal<ResponsiveCarouselOptions[]> {
    return signal([
      {
        breakpoint: '1024px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '640px',
        numVisible: 1,
        numScroll: 1,
      },
    ]);
  }
}
